import React from 'react';
const tomos = [{
  emoji: '📘',
  title: 'Tomo 1 — El Shock de 21 Días',
  desc: 'El protocolo completo. Cómo funciona la cetosis, cómo entrar en ella en 72 horas, qué esperar cada día y cómo no abandonar en el día 4 que es cuando la mayoría se cae.'
}, {
  emoji: '📗',
  title: 'Tomo 2 — Desayunos Criollos Keto',
  desc: '68 desayunos keto con ingredientes argentinos. Sin harina de almendras, sin productos importados. Huevos, manteca, queso, panceta y mate sin azúcar. Lo que ya tenés en casa.'
}, {
  emoji: '📙',
  title: 'Tomo 3 — El Almuerzo del Laburante Keto',
  desc: 'Para el que trabaja y necesita viandas rápidas, menús de cantina y opciones que no requieran cocinar a las 6 de la mañana. Almuerzos en 15 minutos o menos.'
}, {
  emoji: '📕',
  title: 'Tomo 4 — Carnes, Aves y Pescados',
  desc: 'El corazón del keto argentino. Bifes, pollo, cerdo, milanesas sin pan rallado, asado completo y pescados. Los cortes económicos de la carnicería de barrio que son 100% keto.'
}, {
  emoji: '📒',
  title: 'Tomo 5 — Sopas, Salsas y Veganos',
  desc: 'Para el invierno, para el que no come carne y para el que quiere variedad. 46 recetas sin proteína animal completamente keto.'
}, {
  emoji: '📓',
  title: 'Tomo 6 — Postres y Antojos Keto',
  desc: '62 recetas dulces sin azúcar ni harina. Mousse de chocolate, cheesecake, alfajores keto, dulce de leche keto y helados. Para que nunca más el antojo te saque del plan.'
}];
const checklist = ['Plan de comidas semanal listo para usar', 'Lista de compras para el súper de barrio', 'Recetas con ingredientes argentinos accesibles', 'Tiempo de preparación real', 'Carbohidratos netos por receta', 'Variantes económicas para presupuesto ajustado', 'Tips para el contexto argentino', 'Protocolo de emergencia para los días difíciles'];
const bonos = [{
  num: '01',
  title: 'Kit de Arranque Keto Argentino en 24 Horas',
  desc: 'Todo lo que necesitás para empezar hoy mismo. Qué sacar de la cocina, qué comprar y qué comer en las primeras 24 horas sin improvisar.',
  value: '$12.000'
}, {
  num: '02',
  title: 'Lista Maestra de Supermercado Keto Argentino',
  desc: 'La guía completa para entrar al súper y saber exactamente qué comprar, qué evitar y cómo no gastar de más. Con lista low cost incluida.',
  value: '$10.000'
}, {
  num: '03',
  title: 'Menú Express de 7 Días para Bajar de Peso',
  desc: 'Una semana completa resuelta. Desayuno, almuerzo, merienda y cena para 7 días sin improvisar, sin contar calorías y sin dejar de comer bien.',
  value: '$12.000'
}, {
  num: '04',
  title: 'Checklist Anti-Antojos Keto',
  desc: 'El sistema completo para cortar el impulso por pan, azúcar y snacks. Protocolos de emergencia, reemplazos inteligentes y scripts mentales para los momentos más difíciles.',
  value: '$9.000'
}, {
  num: '05',
  title: 'Recetario Ultra Rápido de 15 Minutos',
  desc: '49 recetas keto para personas ocupadas. Desayunos, almuerzos y cenas en 15 minutos o menos con ingredientes de almacén argentino.',
  value: '$10.000'
}, {
  num: '06',
  title: 'Tracker de Progreso Keto 21 Días',
  desc: 'El sistema completo para registrar tu avance día por día, ver resultados reales más allá de la balanza y no abandonar antes de ver los resultados.',
  value: '$9.000'
}];
export function SolutionSection() {
  return <section className="py-16 md:py-24 bg-white/70 backdrop-blur-md border-y border-green-100" data-id="element-149">
      <div className="max-w-6xl mx-auto px-4" data-id="element-150">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16" data-id="element-151">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-green-50 text-green-600 font-bold text-sm mb-6 border border-green-200" data-id="element-152">
            🔥 MEGA PACK CETOSIS EXTREMA 21 DÍAS
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-green-900 mb-4" data-id="element-153">
            6 Tomos + 6 Bonos
          </h2>
          <p className="text-lg md:text-xl text-slate-600" data-id="element-154">
            El sistema keto completo para Argentina
          </p>
          <p className="text-base text-slate-500 mt-2" data-id="element-155">
            400+ páginas — Todo resuelto.
          </p>
        </div>

        {/* Tomos Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 mb-12 md:mb-16" data-id="element-156">
          {tomos.map((t, i) => <div key={i} className="bg-white border border-green-100 rounded-2xl p-6 md:p-8 hover:border-green-300 transition-all group shadow-sm" data-id="element-157">
              <div className="text-4xl md:text-5xl mb-5 group-hover:scale-110 transition-transform origin-left" data-id="element-158">
                {t.emoji}
              </div>
              <h3 className="text-lg md:text-xl font-bold text-green-900 mb-3" data-id="element-159">
                {t.title}
              </h3>
              <p className="text-slate-600 leading-relaxed text-sm md:text-base" data-id="element-160">
                {t.desc}
              </p>
            </div>)}
        </div>

        {/* Checklist */}
        <div className="max-w-3xl mx-auto bg-green-50 border border-green-200 rounded-2xl md:rounded-3xl p-6 md:p-10 mb-20 md:mb-28" data-id="element-161">
          <h3 className="text-xl md:text-2xl font-bold text-green-900 mb-6 md:mb-8 text-center" data-id="element-162">
            Cada tomo incluye:
          </h3>
          <div className="grid md:grid-cols-2 gap-3 md:gap-4" data-id="element-163">
            {checklist.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-164">
                <span className="text-green-600 mt-0.5 shrink-0" data-id="element-165">✅</span>
                <span className="text-slate-700 font-medium text-sm md:text-base" data-id="element-166">
                  {item}
                </span>
              </div>)}
          </div>
        </div>

        {/* Bonuses Header */}
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16" data-id="element-167">
          <h2 className="text-3xl md:text-5xl font-bold text-green-900 mb-4" data-id="element-168">
            🎁 6 BONOS ESTRATÉGICOS
          </h2>
          <p className="text-lg text-green-600 font-semibold uppercase tracking-wider" data-id="element-169">
            Siempre incluidos
          </p>
        </div>

        {/* Bonuses Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 mb-12 md:mb-16" data-id="element-170">
          {bonos.map((b, i) => <div key={i} className="bg-gradient-to-b from-white to-green-50 border border-green-200 rounded-2xl p-6 md:p-8 relative overflow-hidden flex flex-col shadow-sm" data-id="element-171">
              <div className="absolute top-0 right-0 w-28 h-28 bg-green-100/50 rounded-bl-full -mr-8 -mt-8" data-id="element-172" />
              <div className="text-green-600 font-mono font-bold text-lg mb-3" data-id="element-173">
                BONO {b.num}
              </div>
              <h3 className="text-lg md:text-xl font-bold text-green-900 mb-3" data-id="element-174">
                {b.title}
              </h3>
              <p className="text-slate-600 text-sm md:text-base mb-6 flex-1" data-id="element-175">
                {b.desc}
              </p>
              <div className="pt-5 border-t border-green-200 flex items-center justify-between" data-id="element-176">
                <span className="text-slate-500 line-through font-mono text-sm" data-id="element-177">
                  {b.value}
                </span>
                <span className="bg-green-600 text-white font-bold px-3 py-1 rounded-md text-xs uppercase tracking-wide" data-id="element-178">
                  Gratis
                </span>
              </div>
            </div>)}
        </div>

        {/* Total Value */}
        <div className="max-w-xl mx-auto text-center bg-green-50 border border-green-200 rounded-2xl p-6 md:p-8" data-id="element-179">
          <div className="text-slate-600 font-medium mb-2 uppercase tracking-wider text-sm" data-id="element-180">
            Valor total bonos
          </div>
          <div className="text-2xl md:text-3xl font-bold" data-id="element-181">
            <span className="line-through text-slate-500 mr-3" data-id="element-182">$62.000</span>
            <span className="text-green-600" data-id="element-183">→ GRATIS con tu Mega Pack</span>
          </div>
        </div>
      </div>
    </section>;
}